import shakebugsService from '@lib/feedback/ShakebugsService'
import { useEffectAsync } from '@lib/hooks/useEffectAsync'

/**
 * Hook to initialize Shakebugs feedback service.
 * Should be called once in _app.tsx.
 */
export const useShakebugs = () => {
    useEffectAsync(async () => {
        await shakebugsService.initialize()
    }, [])
}
